import axios from "axios";
import env from "react-dotenv";

class LocationService {

    API_IP = env.API_LOCATION_IP;
    
    async getIp() {
        
        return '189.16.35.34';
        /*
        return axios
            .get(this.API_IP, {})
            .then((response: any) => {
                let data = response.data; 
                return data.ip;
            })
            .catch((error: any) => {
                console.log(`Exception in 'LocationService' from method get 'getIp'`);
                if (error.code === "ERR_NETWORK") {
                    throw new Error(`Ops !!! Não foi possivel conectar ao serviço de ip.`);
                } else {
                    const responseMessage = (
                        error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    throw new Error(responseMessage);
                }
            });
            */
    }

    async getCityByIp() {

        return {
            "ip": "189.16.35.34",
            "network": "189.16.32.0/20",
            "version": "IPv4",
            "city": "São Paulo",
            "region": "São Paulo",
            "region_code": "SP",
            "country": "BR",
            "country_name": "Brazil",
            "country_code": "BR",
            "country_code_iso3": "BRA",
            "country_capital": "Brasilia",
            "country_tld": ".br",
            "continent_code": "SA",
            "in_eu": false,
            "postal": "01000",
            "latitude": -23.6301,
            "longitude": -46.6378,
            "timezone": "America/Sao_Paulo",
            "utc_offset": "-0300",
            "country_calling_code": "+55",
            "currency": "BRL",
            "currency_name": "Real",
            "languages": "pt-BR,es,en,fr",
            "country_area": 8511965.0,
            "country_population": 209469333,
            "asn": "AS4230",
            "org": "CLARO S.A."
        };
        /*
        return axios
            .get(this.API_IP, {})
            .then((response: any) => {
                return response.data; 
            })
            .catch((error: any) => {
                console.log(`Exception in 'LocationService' from method get 'getCityByIp'`);
                if (error.code === "ERR_NETWORK") {
                    throw new Error(`Ops !!! Não foi possivel conectar ao serviço de ip por cidade.`);
                } else {
                    const responseMessage = (
                        error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    throw new Error(responseMessage);
                }
            });
            */
    }
    
    async now() {
        
        return '189.16.35.34';
        /*
        return axios
            .get(this.API_IP, {})
            .then((response: any) => {
                return response.data; 
            })
            .catch((error: any) => {
                console.log(`Exception in 'LocationService' from method get 'now'`);
                if (error.code === "ERR_NETWORK") {
                    throw new Error(`Ops !!! Não foi possivel conectar ao serviço de localização.`);
                } else {
                    const responseMessage = (
                        error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    throw new Error(responseMessage);
                }
            });
            */
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LocationService();